export default "__VITE_ASSET__D0nkqNTO__"